import { render, staticRenderFns } from "./NewProcessDefinitionStep.vue?vue&type=template&id=02b63a11&scoped=true&"
import script from "./NewProcessDefinitionStep.vue?vue&type=script&lang=js&"
export * from "./NewProcessDefinitionStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b63a11",
  null
  
)

export default component.exports